import { render, staticRenderFns } from "./CategoryMenu.vue?vue&type=template&id=d5b11146&scoped=true&"
import script from "./CategoryMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b11146",
  null
  
)

export default component.exports